import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Divider, List, Typography } from "@mui/material";

// project imports
import NavItem from "../NavItem";
import NavCollapse from "../NavCollapse";
import { color } from "utils/color";

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
  const theme = useTheme();

  // menu list collapse & items
  const items = item.children?.map((menu) => {
    switch (menu.type) {
      case "collapse":
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case "item":
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        subheader={
          item.title && (
            <Typography
              variant="caption"
              sx={{
                ...theme.typography.menuCaption,
                color: color.fg,
                textTransform: "uppercase",
                letterSpacing: 0.5,
              }}
              display="block"
              gutterBottom
            >
              {item.title}
              {item.caption && (
                <Typography
                  variant="caption"
                  sx={{
                    ...theme.typography.subMenuCaption,
                    color: color.fg,
                    opacity: 0.8,
                  }}
                  display="block"
                  gutterBottom
                >
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
        sx={{
          //   backgroundColor: color.bg,
          color: color.bg,
          borderRadius: "10px",
          p: 0.5,
          "& .MuiListItemButton-root": {
            color: color.bg,
            borderRadius: "8px",
            transition: "none",
            "&:hover": {
              backgroundColor: color.hv, // ✅ removes hover background
            },
          },

          ".MuiListItem-selected &": {
            color: color.bg,
          },
          "& .MuiListItem-root": {
            color: color.bg + "!important",
            // backgroundColor: color.hv,
          },
          "& .MuiTypography-root": {
            color: color.bg,
          },
        }}
      >
        {items}
      </List>

      {/* group divider */}
      <Divider
        sx={{
          mt: 0.25,
          mb: 1.25,
          borderColor: color.fg,
          opacity: 0.3,
        }}
      />
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object,
};

export default NavGroup;
